/*
Definiton of global variables for the logic part
*/

//The general API endpoint for all requests
export const API_ENDPOINT = "https://cloud.schmuckli.net";
